//Constants for column content fields
//Title Fields
export const PRE_TITLE_1 = 'pre-title-1';
export const SHORT_TITLE_1 = 'short-title-1';
export const LONG_TITLE_1 = 'long-title-1';
export const PRE_TITLE_2 = 'pre-title-2';
export const SHORT_TITLE_2 = 'short-title-2';
export const LONG_TITLE_2 = 'long-title-2';
export const POST_TITLE = 'post-title';

//Date, ReadTime, Author
export const DATE = 'date';
export const READ_TIME = 'readTime';
export const AUTHOR = 'author';

//Text fields
export const TEXT_1 = 'text-1';
export const TEXT_1_PARA = 'text-1-para';
export const TEXT_2 = 'text-2';

//SubHeading/ Text Fields
export const SUB_HEADING = 'subHeading';

//SubText Field
export const SUB_TEXT = 'subText';

//PostTextHTML Field
export const POST_TEXT_HTML = 'postTextHTML';

//BulletPoints Field
export const BULLET_POINTS = 'bulletPoints';

//Image Fields
export const IMAGES = 'images';
export const IMAGE_URL = 'image-url';
export const IMAGE_ALIGNMENT = 'image-alignment';
export const IMAGE_CAPTION = 'image-caption';
export const IMAGE_ALTTEXT = 'image-altText';

//CTA fields
export const PRIMARY_CTA = 'primaryCTA';
export const SECONDARY_CTA = 'secondaryCTA';


//Button details
export const PRIMARY_BUTTON = 'primaryButton';
export const SECONDARY_BUTTON = 'secondaryButton';

//Icon field
export const ICON = 'icon';

//Additional Fields
export const TEXT = 'text';
export const URL = 'url';
export const URL_ALT = 'urlAlt';
export const TARGET = 'target';
export const HEADING = 'heading';
export const BUTTON = 'button';
export const LINK = 'link';

//Buffer Content
export const BUFFER_CONTENT = 'bufferContent';

//Url
export const HTTP_URL = 'http';

//Environments
export const DEV = '.dev.';
export const QA = '.qa.';
export const STAGE = '.stage.';

export const MMM_ID = 'mmm-id-';


export const MMM_0001 = 'MMM-0001';
export const MMM_0003 = 'MMM-0003';

export const MYPRU_APPNAME = 'MyPru';


